<template>
	<!-- 新追加费用弹框 -->
	<common-modal :showClose="true" @close-modal="onCloseModalClick">
	    <div class="modal">
	        <div class="title">追加订单费用</div>
	        <div class="add-wrap">
				<p class="aim"><span>追加费用</span><b><input type="tel" v-model="addPrice" @focus="inputVal"></b><span>元</span></p>
				<div class="add-money">
					<span v-for='(item,index) in moneyList' :key="index" :class='moneyFlag==index?"current":""' @click="selectAdd(index)">{{item}}元</span>
				</div>
			</div>
			<div class="type-wrap">
				<p class="money-type">费用类型</p>
				<ul class="type-content">
					<li v-for="(item,index) in moneyTypeList" :key="index" @click="selectType(index)">
					    <span class="select-mark" :class='typeFlag==index?"done":"undone"'></span>
					    <span class="money-text">{{item}}</span>
					</li>
					<span class="other" v-if="typeFlag==4"><input type="text" class="other-tips" v-model="addContent"></span>
				</ul>
			</div>
			
	        <div class="modal-submit submit-mt" @click='getOrderAdd'>确定</div>
	    </div>
	</common-modal>
</template>

<script>
	import CommonModal from './CommonModal';
	import {getOrderAdd} from '@/api/order'
    export default {
        data(){
            return{
				moneyFlag:0,
				typeFlag:0,
				moneyList:["50","100","200","500"],
				moneyTypeList:['加急费','补偿费','垫付费','打赏金','其它'],
				addContent:'加急费',
				addPrice:"50"				//追加金额
            }
        },
		props:{
			order_uuid:{
				type:String
			}
		},
		
        methods:{
			onCloseModalClick(){
				this.$emit("close-modal")
			},
			
			// 选择追加类型
			selectType(index){
				this.typeFlag = index;
				if(this.typeFlag!=4){
					this.addContent = this.moneyTypeList[index]
				}else{
					this.addContent = ""
				}
			},
			
			// 选择追加金额
			selectAdd(index){
				this.moneyFlag = index;
				this.addPrice = this.moneyList[index];
			},
			
			//用户只要输入金额，金额选择按钮变为未选择状态
			inputVal(){
				this.moneyFlag = -1
			},
			
			// 生成追加金额订单
			async getOrderAdd(){
				if(!this.addPrice){
					window.toast("请输入追加金额金额","txt");
					return
				}
			    if(!this.addContent){
			    	window.toast("请输入追加金额内容","txt");
			    	return
			    }
				let obj={order_uuid:this.order_uuid,add_price:this.addPrice,add_content:this.addContent,add_remarks:this.addContent}
			    const { data, status } = await getOrderAdd(obj);
			    if (status !== 200) return //成功下单之后，展示支付,并且标记为追加订单支付
				this.$emit("getOrderAdd",this.addPrice,data.add_order_uuid);
			},
        },
		components:{
			CommonModal
		}
        
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#FFF}
	.modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.title{padding: 12px 20px 0 20px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;}

	/* 新追加费用弹框 */
	.add-wrap{margin: 47px 0 33px 25px;}
	.aim{font-size:15px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(20,20,20,1)}
	.aim b{display: inline-block;width:132px;border-bottom: 1px solid #979797;margin: 0 10px;vertical-align: bottom;}
	.add-money{display: flex;align-items: center;margin-top: 15px;}
	.add-money span{width:57px;height: 27px;margin-right: 11px;line-height: 27px;border-radius:2px;border:1px solid rgba(153,153,153,1);font-size:12px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(153,153,153,1);text-align:center}
	.add-money span::nth-child(4n){margin-right: 0}
	.type-wrap{margin-left: 25px}
	.money-type{font-size:15px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(20,20,20,1);margin-bottom: 13px}
	.type-content{display: flex;flex-wrap: wrap;align-items: center;}
	.type-content li{margin-right: 34px;margin-bottom: 13px}
	.type-content li:nth-child(3n){margin-right: 0px;}
	.type-content li:nth-child(5){margin-right: 0px;}
	.done{background: url(../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.money-text{display: inline-block;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(174,174,174,1);vertical-align: top;}
	.other{display: inline-block;vertical-align: bottom;width: 113px;border-bottom: 1px solid #C1C1C1;margin-bottom: 0.3rem;}
	.modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}
	.submit-mt{margin-top: 31px}
	.select-mark{display: inline-block;width:17px;height:17px;border-radius: 50%;margin-right: 7px;vertical-align: top;margin-top: 4px}
	.add-money .current{background:rgba(65,132,244,1);color:rgba(255,255,255,1);border:1px solid rgba(65,132,244,1);}
	.other-tips{padding-left: 0.2rem;width: 100%;}
</style>
